import { createStyles, makeStyles, Paper, Theme } from '@material-ui/core'
import React, { CSSProperties, ReactElement, useEffect, useRef } from 'react'
import { TargetPriceGraphData } from '../../useBomItemDetails'
import { ChildrenSummaryTooltip } from './ChildrenSummaryTooltip'
import { MaterialTooltip } from './MaterialTooltip'
import { PartOrAssemblyTooltip } from './PartOrAssemblyTooltip'
import { TotalTooltip } from './TotalTooltip'
import { WorkingStepSummaryTooltip } from './WorkingStepSummaryTooltip'
import { WorkingStepTooltip } from './WorkingStepTooltip'

export type TargetPriceTooltipTypes =
  | 'WorkingStep'
  | 'WorkingStepSummary'
  | 'Part'
  | 'ChildrenSummary'
  | 'Material'
  | 'Total'

export type TargetPriceTooltipPayload = {
  data: TargetPriceGraphData
  tooltipDataType: TargetPriceTooltipTypes
}

export type TargetPriceTooltipProps = {
  position: { x: number; y: number }
  payload: TargetPriceTooltipPayload
  onClose: () => void
  boundaries?: {
    top: number
    right: number
    bottom: number
    left: number
  }
  containerRef?: React.RefObject<HTMLDivElement>
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-around',
      padding: theme.spacing(0, 2),
      //   padding: theme.spacing(2),
    },
  })
)

export const TargetPriceTooltip = (props: TargetPriceTooltipProps) => {
  const cn = useStyles()

  const stylePosition: CSSProperties = {
    position: 'fixed',
    top: props.position.y || -20000 + 5,
    left: props.position.x || -20000 + 5,
    zIndex: 10,
  }

  const divRef = useRef<HTMLDivElement>(undefined)

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (divRef.current) {
        const topPosition = e.clientY - divRef.current.clientHeight / 4 + 12

        let leftPosition = 0

        if (window.innerWidth - 12 - e.clientX > divRef.current.clientWidth) {
          // shows on the right
          leftPosition = e.clientX + 12
          // divRef.current.style.transform = 'translateX(0)'
        } else {
          // shows on the left
          leftPosition = e.clientX - divRef.current.clientWidth - 12
        }

        if (props.boundaries) {
          if (
            topPosition <=
              props.boundaries.top -
                (props.boundaries.bottom - props.boundaries.top) ||
            topPosition >= props.boundaries.bottom ||
            leftPosition <= props.boundaries.left ||
            leftPosition >= props.boundaries.right
          ) {
            props.onClose()
            return
          }
        }

        divRef.current.style.top = `${topPosition}px`
        divRef.current.style.left = `${leftPosition}px`
      }
    }

    props.containerRef?.current?.addEventListener('mousemove', handleMouseMove)

    return () => {
      props.containerRef?.current?.removeEventListener(
        'mousemove',
        handleMouseMove
      )
    }
  }, [props])

  if (!props.payload?.data || !props.payload?.tooltipDataType) {
    return <div ref={divRef} style={stylePosition} />
  }

  const Tooltips: Record<TargetPriceTooltipTypes, ReactElement> = {
    Part: <PartOrAssemblyTooltip bomItemId={props.payload.data.id} />,
    WorkingStep: <WorkingStepTooltip data={props.payload.data} />,
    WorkingStepSummary: <WorkingStepSummaryTooltip data={props.payload.data} />,
    ChildrenSummary: <ChildrenSummaryTooltip data={props.payload.data} />,
    Material: <MaterialTooltip data={props.payload.data} />,
    Total: <TotalTooltip data={props.payload.data} />,
  }

  const TooltipComponent = Tooltips[props.payload?.tooltipDataType]

  return (
    <div style={stylePosition} ref={divRef}>
      {/* <ClickAwayListener onClickAway={props.onClose}> */}
      <Paper className={cn.root}>{TooltipComponent}</Paper>
      {/* </ClickAwayListener> */}
    </div>
  )
}
